import { Component, OnInit } from '@angular/core';
import { OptiData } from '../../../_models/opti_data';
import { OptiPiece } from '../../../_models/opti_piece';
import * as fromOpti from '../../../opti/state/opti.reducer';
import * as optiActions from '../../../opti/state/opti.actions';
import * as easelActions from '../../../maestros/easel/state/easel.actions';
import * as fileActions from '../../../file/state/file.actions';

import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Component({
  templateUrl: './opti-shell.component.html'
})

export class OptiShellComponent implements OnInit {

  // Id del usuario actual logueado.
  current_user_id: number;
  current_group_id: number;
  current_username: string;

  // componentActive = true;
  // errorMessage$: Observable<string>;
  optiList$: Observable<OptiData[]>;
  compactList$: Observable<any>;
  retalList$: Observable<OptiPiece[]>;
  currentOpti$: Observable<OptiData>;
  filterFields$: Observable<any>;

  constructor(
	private storeRoot: Store<fromRoot.State>,
    private store: Store<fromOpti.State>
  ) {
	
	// Se cargan los caballetes
    this.store.dispatch( new easelActions.LoadEasels({setup_user: 'Cut', f_type: 3, f_active: false}));
  }

  ngOnInit() {

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_group_id = Number(localStorage.getItem('group_id'));
    this.current_username = localStorage.getItem('username');

    console.log('->->< Usuario actual logueado: ' + this.current_user_id + ' ;group_id = ' + this.current_group_id);
    console.log(this.current_username);

    this.optiList$ = this.store.pipe(select(fromOpti.getOptiList)) as Observable<OptiData[]>;
    this.compactList$ = this.store.pipe(select(fromOpti.getCompactList)) as Observable<any>;
    this.currentOpti$ = this.store.pipe(select(fromOpti.getCurrentOpti)) as Observable<OptiData>;
    this.retalList$ = this.store.pipe(select(fromOpti.getRetalOptiList)) as Observable<OptiPiece[]>;
    this.filterFields$ = this.store.pipe(select(fromOpti.getFilterFields)) as Observable<any>;
    
  } // End function OnInit
  
  compactOpti(searchParams: any): void {

    console.log('---> compactOpti searchParam ');
    console.log(searchParams);

    //this.inventories$ = this.store.pipe(select(fromOpti.getInventoryList)) as Observable<Inventory[]>;

    this.store.dispatch( new optiActions.CompactOpti(searchParams));

  } // End function compactOpti
  
  printCompactOpti(compactListIn: any): void {

    console.log('---> printCompactOpti compactListIn:');
    console.log(compactListIn);

    this.store.dispatch( new fileActions.PrintEasels(compactListIn));

  } // End function printCompactOpti

  searchOpti(searchParams: any): void {

    console.log('---> searchOpti searchParam ');
    console.log(searchParams);

    //this.inventories$ = this.store.pipe(select(fromOpti.getInventoryList)) as Observable<Inventory[]>;

    this.store.dispatch( new optiActions.LoadOpti(searchParams));

    // Se guarda el valor de los filtros de búsqueda.
    this.store.dispatch( new optiActions.SetFilterFields(searchParams));

  } // End function searchOpti

  setCurrentOpti(optiIn: OptiData): void {

    console.log('---> setCurrentOpti optiIn ');
    console.log(optiIn);

    this.store.dispatch( new optiActions.SetCurrentOpti(optiIn));
  } // End function setCurrentOpti
  
  async updateRetalList(searchParams) {

    console.log('---> updateRetalList opti-shell:');
    console.log(searchParams);

    const aux = await this.store.dispatch( new optiActions.LoadRetalOpti(searchParams));

    return aux;
  }
  
  async chargeOpti(searchParams) {

    console.log('---> chargeOpti opti-shell:');
    console.log(searchParams);

    const aux = await this.store.dispatch( new optiActions.ChargeOpti(searchParams));

    return aux;
  }
  
  deleteOpti(opti_in: OptiData): void {

    console.log('---> deleteOpti: ');
    console.log(opti_in);

    this.store.dispatch( new optiActions.DeleteOpti(opti_in));

  } // End function deleteOpti
  
  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando file-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal

  // Función para "mostrar/ocultar" el icono de "carga" que bloquea la página.
  changingLoading(value: boolean) {
      console.log('---->>>>.... file-shell ejecutando changingLoading: ' + value);
      this.storeRoot.dispatch( new rootActions.ChangeLoading6(value));
  } // End function changingLoading
  
  // Función para "mostrar/ocultar" el icono de "carga" que bloquea la página.
  changingLoading2(value: boolean) {
      console.log('---->>>>.... file-shell ejecutando changingLoading2: ' + value);
      this.storeRoot.dispatch( new rootActions.ChangeLoading5(value));
  } // End function changingLoading

} // End class OptiShellComponent
